import { AxiosInstance, AxiosResponse } from 'axios';
import { Response, BaseResponse } from 'api/api.types';

export class ApiInstance {
  protected http: AxiosInstance;

  constructor(http: AxiosInstance) {
    this.http = http;
  }

  // eslint-disable-next-line class-methods-use-this
  async execute<T extends Response>(request: Promise<AxiosResponse<T>>): Promise<BaseResponse<T>> {
    return request.then(response => new BaseResponse(response.data));
  }
}
